import Button, { ButtonProps } from 'react-bootstrap/Button';
import { FC, ReactElement } from 'react';

const SecondaryButton: FC<ButtonProps> = ({ className, ...props }: ButtonProps): ReactElement => {
  return <Button variant="outline-primary" className={className} {...props} />;
};

export default SecondaryButton;
